import React from 'react';
import { Button, Icon } from '@kajabi/sage-react';
import { useFormikContext } from 'formik';

import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import { PromptFormValuesType } from 'common/components/CopyMagic/CopyMagic.types';

type Props = {
  tryAgain?: boolean;
  fullWidth?: boolean;
};

const GenerateButton = ({ tryAgain = false, fullWidth = false }: Props) => {
  const { isValid, submitForm } = useFormikContext<PromptFormValuesType>();
  const { loading } = useUiResourceContext();
  const color = tryAgain ? Button.COLORS.SECONDARY : Button.COLORS.PRIMARY;
  const icon = tryAgain ? Icon.ICONS.SYNC : null;

  return (
    <Button
      disabled={!isValid || !!loading}
      color={color}
      onClick={submitForm}
      fullWidth={fullWidth}
      icon={icon}
    >
      {tryAgain ? 'Try again' : 'Generate'}
    </Button>
  );
};

export default GenerateButton;
